import React from "react";
import PropTypes from "prop-types";
//Material imports
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import withStyles from "@mui/styles/withStyles";
import CircularProgress from "@mui/material/CircularProgress";
//Limitless imports
import { withi18n } from "../../../../customer/components";
const LoadingIconButton = ({
  classes,
  t,
  toolTipTitle,
  onClick,
  loading,
  disabled,
  ariaLabel,
  icon
}) => {
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: t(toolTipTitle)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.buttonWrapper
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": t(ariaLabel),
    className: classes.icon,
    onClick: onClick,
    disabled: disabled,
    size: "large"
  }, icon), loading && /*#__PURE__*/React.createElement(CircularProgress, {
    className: classes.progress,
    color: "secondary"
  })));
};
const styles = theme => ({
  icon: {
    "&:hover": {
      color: theme.palette.primary.main
    }
  },
  buttonWrapper: {
    display: "inline-flex",
    verticalAlign: "middle"
  },
  progress: {
    position: "absolute",
    padding: 4
  }
});
export default withStyles(styles)(withi18n(LoadingIconButton));
LoadingIconButton.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  toolTipTitle: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  icon: PropTypes.node.isRequired,
  ariaLabel: PropTypes.string
};